import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'reverse' })

export class ReversePipe implements PipeTransform {
  transform(value) {
    return value.slice().reverse();
    /// note that slice reverse will reverse the index of the array, so you'll have to do something like (data.distinctWarehouses.length - 1 - indexVal) to use as a variable
  }
}

